import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

interface AppBarContentProps {
  children: React.ReactNode;
  sx?: any;
}

// Mirrors the sidebar offset from ResponsiveContainer so AppBar actions
// align with page content on desktop.
const SIDEBAR_WIDTH = 90;
const SIDEBAR_GAP = 10;

const AppBarContent: React.FC<AppBarContentProps> = ({ children, sx = {} }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', px: 2, ...sx }}>{children}</Box>;
  }

  return (
    <Box sx={{ width: '100%', pl: `${SIDEBAR_WIDTH + SIDEBAR_GAP}px`, boxSizing: 'border-box' }}>
      <Box sx={{ maxWidth: { md: 1200, lg: 1400 }, mx: 'auto', px: { md: 4, lg: 5 }, display: 'flex', alignItems: 'center', ...sx }}>
        {children}
      </Box>
    </Box>
  );
};

export default AppBarContent;
